import _ from 'lodash';

export default (function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx) {
    var translateFn = TranslateService.instant;

    function wrappedLoadSave(action, model) {
        var promise = action.call(undefined, model);
        return promise.then(function (submissionDTO) {
            return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelCtx);
        });
    }

    var ACTION_MSG = {
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        }
    };

    var ACTIONS = {
        saveDraftSubmission: function saveDraftSubmission(_ref) {
            var submission = _ref.value;
            return wrappedLoadSave(LoadSaveService.saveSubmission, submission);
        }
    };

    return {
        contactDetails: function contactDetails(step, junction) {

            function hasEmailAddress1(_ref2) {
                var submission = _ref2.value;

                return !!_.get(submission, 'persons[0].emailAddress1');
            }

            step('cpContactDetails', true).onNext.branch(function (model) {
                return model.quoteID.value ? 'cpPostContactDetails' : 'cpContactDetailsComplete';
            }).skipOnResumeIf(hasEmailAddress1).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Your Info');
            });

            junction('cpPostContactDetails').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSG.saveSubmission).thenGoTo('cpContactDetailsComplete', 'error');

            junction('cpContactDetailsComplete');
        },
        coverables: function coverables(step, junction) {
            step('cpBuildingsAndLocations', true).onNext.goTo('cpCoverablesComplete').skipOnResumeIf(function (_ref3) {
                var submission = _ref3.value;
                return submission.baseData.periodStatus === 'Quoted';
            }).label(function () {
                return translateFn('quoteandbind.cp.wizard.step.Buildings and Locations');
            });

            junction('cpCoverablesComplete');
        },
        moreInfo: function moreInfo(step, junction) {
            step('cpPolicyInfo', true).skipOnResumeIf(function (_ref4) {
                var submission = _ref4.value;

                return submission.baseData && submission.baseData.accountHolder && submission.baseData.accountHolder.emailAddress1 && (submission.baseData.accountHolder.homeNumber || submission.baseData.accountHolder.workNumber || submission.baseData.accountHolder.cellNumber);
            }).onNext.goTo('cpMoreInfoComplete').isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Policy Info');
            });

            junction('cpMoreInfoComplete');
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=cp!./common/js/src/edge/quoteandbind/cp/config/FlowConfig.js
// module id = 474
// module chunks = 0